import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Access } from '../data/access';
import { environment } from '../../environments/environment';
import { AccessEmployee } from '../data/access-employee';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private http = inject(HttpClient);

  usernameContext: string | undefined;
  usernameContextFirstName: string | undefined;
  usernameContextLastName: string | undefined;
  usernameContextToApprove: boolean | undefined;

  private controllerURL = '/api/accesses';

  public getGivenAccess(): Observable<Access[]> {
    return this.http.get<Access[]>(environment.apiUrl + this.controllerURL + '/given');
  }

  public getReceivedAccess(): Observable<Access[]> {
    return this.http.get<Access[]>(environment.apiUrl + this.controllerURL + '/received');
  }

  public getEmployees(): Observable<AccessEmployee[]> {
    return this.http.get<AccessEmployee[]>(environment.apiUrl + this.controllerURL + '/employees');
  }

  public createAccess(body: { accessForUsername: string; accessForUidNumber: string; toApprove: boolean; notifyToApprove: boolean }): Observable<string> {
    return this.http.post<string>(environment.apiUrl + this.controllerURL, body);
  }

  public revoke(id: string): Observable<void> {
    return this.http.delete<void>(environment.apiUrl + this.controllerURL + '/' + id);
  }
}
